import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination } from "@mui/material";
import PaginationItem from "@mui/material/PaginationItem";
import { styled } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import BryxColors from "../../types/theme";
const prevButton = () => {
    return (_jsx(SvgIcon, { viewBox: "0 0 6 8", sx: {
            width: "6px",
            height: "8px",
            "&.MuiSvgIcon-root": { color: "#7D7D7D" },
            "&.MuiSvgIcon-colorDisabled": { color: "#7D7D7D" },
        }, children: _jsx("path", { d: "M5 0.469994C4.74 0.209994 4.32 0.209994 4.06 0.469994L1 3.52999C0.74 3.78999 0.74 4.20999 1 4.46999L4.06 7.52999C4.32 7.78999 4.74 7.78999 5 7.52999C5.26 7.26999 5.26 6.84999 5 6.58999L2.41333 3.99666L5 1.40999C5.25333 1.14999 5.25333 0.723327 5 0.469994Z", fill: "#7D7D7D" }) }));
};
const nextButton = () => {
    return (_jsx(SvgIcon, { viewBox: "0 0 6 8", sx: {
            width: "6px",
            height: "8px",
            "&.MuiSvgIcon-root": { color: "#7D7D7D" },
            "&.MuiSvgIcon-colorDisabled": { color: "#7D7D7D" },
        }, children: _jsx("path", { d: "M1.00001 7.53001C1.26001 7.79001 1.68001 7.79001 1.94001 7.53001L5.00001 4.47001C5.26001 4.21001 5.26001 3.79001 5.00001 3.53001L1.94001 0.470007C1.68001 0.210007 1.26001 0.210007 1.00001 0.470007C0.740007 0.730007 0.740007 1.15001 1.00001 1.41001L3.58667 4.00334L1.00001 6.59001C0.746674 6.85001 0.746674 7.27667 1.00001 7.53001Z", fill: "#7D7D7D" }) }));
};
const BryxPagination = styled((props) => (_jsx(Pagination, { ...props, shape: "rounded", size: "small", renderItem: (item) => _jsx(PaginationItem, { components: { previous: prevButton, next: nextButton }, ...item }) })))(({ variant, theme }) => {
    const palette = theme.palette.mode;
    return {
        "& .MuiButtonBase-root.MuiPaginationItem-root": {
            width: "28px",
            height: "28px",
            fontSize: "13px",
            lineHeight: "18px",
            color: BryxColors.notify(palette, "inactive"),
            "&.Mui-selected": {
                backgroundColor: BryxColors.brand3(palette),
                color: BryxColors.brandPrimary(palette),
            },
            "&.Mui-disabled": {
                color: "#7D7D7D", // this is not in the palette
            },
        },
        "& .MuiPaginationItem-root.MuiPaginationItem-ellipsis": {
            color: `${BryxColors.notify("light", "inactive")} !important`,
        },
    };
});
export default BryxPagination;
